import { AxiosInstance } from "axios"

const workerEndPoint = `${import.meta.env.VITE_WORKER_API}/workerapi/v1`

export const getAnalytics = async (api:AxiosInstance, device: any, start: string, end: string, interval: string) => {
  const { data } = await api.post(`${workerEndPoint}/data?start=${start}&end=${end}&interval=${interval}`, device)
  return data
}
